import ValidationResult from 'domain/types/global/validationResult';
import { CalcularImpostoResponse } from '../../../../../core/carteira/src/types/deposito/calcularImpostoResponse';
import { GetMeioPagamentoResponse } from '../../../../../core/carteira/src/types/deposito/getMeioPagamentoResponse';
import { DepositoPixResponse } from './../../../../../core/carteira/src/types/deposito/depositoPixResponse';
import { DepositoBoletoResponse } from 'carteira/src/types/deposito/depositoBoletoResponse';
import { BoletoResponse } from 'carteira/src/types/boleto/boletoResponse';

export const DEPOSITO_PIX = 'DEPOSITO_PIX';
export const PAGAMENTO_PIX = 'PAGAMENTO_PIX';

export const DEPOSITO_DEBITO = 'DEPOSITO_DEBITO';
export const DEPOSITO_CREDITO = 'DEPOSITO_CREDITO';
export const DEPOSITO_BOLETO = 'DEPOSITO_BOLETO';
export const CALCULAR_IMPOSTO = 'CALCULAR_IMPOSTO';
export const GET_MEIO_PAGAMENTO = 'GET_MEIO_PAGAMENTO';

export const GET_BOLETOS = 'GET_BOLETOS';
export const BOLETO_GERADO = 'BOLETO_GERADO';

export interface DepositoState {
  DepositoPix: DepositoPixResponse | undefined,
  PagamentoPix: string | undefined,

  DepositoDebito?: ValidationResult,
  DepositoCredito?: ValidationResult,
  DepositoBoleto?: ValidationResult,
  CalcularImposto: CalcularImpostoResponse[],
  GetMeioPagamento: GetMeioPagamentoResponse[],

  GetBoletos: BoletoResponse[],

  BoletoGerado: DepositoBoletoResponse | undefined,
}

export interface DepositoPixAction {
  type: typeof DEPOSITO_PIX,
  payload: DepositoPixResponse | undefined
}

export interface PagamentoPixAction {
  type: typeof PAGAMENTO_PIX,
  payload: string | undefined
}

export interface DepositoDebitoAction {
  type: typeof DEPOSITO_DEBITO,
  payload: ValidationResult
}

export interface CalcularImpostoAction {
  type: typeof CALCULAR_IMPOSTO,
  payload: CalcularImpostoResponse[]
}

export interface GetMeioPagamentoAction {
  type: typeof GET_MEIO_PAGAMENTO,
  payload: GetMeioPagamentoResponse[]
}

export interface GerandoBoletoAction {
  type: typeof BOLETO_GERADO,
  payload: DepositoBoletoResponse | undefined
}

export interface GetBoletoAction {
  type: typeof GET_BOLETOS,
  payload: BoletoResponse[]
}

export type DepositoActionTypes =
  DepositoPixAction |
  PagamentoPixAction |
  CalcularImpostoAction |
  DepositoDebitoAction |
  GetMeioPagamentoAction |
  GerandoBoletoAction |
  GetBoletoAction